import ClickObserver from "./ClickObserver";
import AObservableSubject from "./AObservableSubject";

/**
 * Subject that will notify all observers after document click.
 *
 * @see ClickObserver
 */
 export default class DocumentClickSubject extends AObservableSubject {

  /**
   * Constructor
   */
  constructor() {
    super();

    /**
     * On document click notfy all available observers
     */
    $(document).click((event) => {
      this.notify($(event.target));
    });
  }

  /**
   * Registers new observer.
   *
   * @param {Function} callback that will be fired on update
   * ! If we want to use callback in instance, we need to bind it when passing to constructor
   */
  register(callback) {
    this.observers.push(new ClickObserver(callback));
  }

  /**
   * Will notify all available observers.
   *
   * @param {Element} $clickedElement jQuery element
   */
   notify($clickedElement) {
    this.observers.forEach( observer => {
      observer.update($clickedElement);
    });
  }
}
